import { Text } from "components/Text"

export const AdvertDescription = ({ advert }) => {
  return (
    <Text variant="body2" className="line-clamp-3">
      {advert.description}
    </Text>
  )
}
